export default "__VITE_ASSET__BemPUiNj__"